<app-header></app-header>
<div class="home-main">
  <div class="container">
    <div class="row justify-content-center home-row">
      <div class="col-md-4 col-sm-6">
        <div class="home-block box" (click)="navigateToKMS()">
          <div class="home-block-icon">
            <img src="../../assets/img/knowledge-icon.png">
          </div>
          <h3>KMS</h3>
          <p>Knowledge Management System</p>
        </div>
      </div>
      <div class="col-md-4 col-sm-6" *ngIf="enableDataInsight">
        <div class="home-block box" (click)="navigateToDataInsight()">
          <div class="home-block-icon">
            <img src="../../assets/img/database.svg">
          </div>
          <h3>Data Insight</h3>
          <p>Analyze and visualize your data</p>
        </div>
      </div>
    </div>
  </div>
</div>
